"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_router_dom_1 = require("react-router-dom");
var mountIsland_1 = require("../mountIsland");
var material_1 = require("@mui/material");
var icons_material_1 = require("@mui/icons-material");
var x_data_grid_1 = require("@mui/x-data-grid");
var LivestreamAttendanceMap_1 = __importDefault(require("./LivestreamAttendanceMap"));
var LivestreamAttendance = function () {
    var _a, _b, _c, _d, _e;
    // selectedEventDateRef removed — date selection uses a controlled select element
    var _f = (0, react_1.useState)([]), events = _f[0], setEvents = _f[1];
    var _g = (0, react_1.useState)(0), selectedEventID = _g[0], setSelectedEventID = _g[1];
    var _h = (0, react_1.useState)(''), selectedEventName = _h[0], setSelectedEventName = _h[1];
    var _j = (0, react_1.useState)([]), eventDates = _j[0], setEventDates = _j[1];
    var _k = (0, react_1.useState)(''), selectedEventDate = _k[0], setSelectedEventDate = _k[1];
    var _l = (0, react_1.useState)([]), statistics = _l[0], setStatistics = _l[1];
    var _m = (0, react_1.useState)(''), error = _m[0], setError = _m[1];
    var _o = (0, react_1.useState)(false), textCopied = _o[0], setTextCopied = _o[1];
    var _p = (0, react_1.useState)(false), open = _p[0], setOpen = _p[1];
    var mountEl = document.getElementById('livestream-attendance');
    var countries = mountEl
        ? (_b = JSON.parse((_a = mountEl.dataset.countries) !== null && _a !== void 0 ? _a : '{}')) !== null && _b !== void 0 ? _b : {}
        : {};
    var googleKey = mountEl ? (_c = mountEl.dataset['google-key']) !== null && _c !== void 0 ? _c : null : null;
    var chooseEvent = function (event) {
        setSelectedEventID(event.target.value);
        var selectedEvent = events.find(function (e) { return e.id === parseInt(event.target.value); });
        if (selectedEvent) {
            setSelectedEventName(selectedEvent.title);
        }
    };
    var filterCountries = function (countryCode) {
        var _a;
        return (_a = countries[countryCode]) !== null && _a !== void 0 ? _a : countryCode;
    };
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get('/api/livestream/list')
            .then(function (response) {
            setEvents(response.data);
        })
            .catch(function () {
            setError('There was an error fetching the events');
        });
    }, []);
    (0, react_1.useEffect)(function () {
        if (selectedEventID) {
            setError('');
            setEventDates([]);
            setSelectedEventDate('');
            setStatistics([]);
            setTextCopied(false);
            axios_1.default
                .get("/api/livestream/attendance/dates?event_id=".concat(selectedEventID))
                .then(function (response) {
                setEventDates(response.data);
            })
                .catch(function () {
                setError('There was an error fetching the event dates');
            });
        }
    }, [selectedEventID]);
    // No-op effect kept for dependency tracking; date selection now handled via select element
    (0, react_1.useEffect)(function () {
        if (selectedEventID && eventDates.length > 0) {
            setSelectedEventDate('');
        }
    }, [eventDates]);
    (0, react_1.useEffect)(function () {
        if (selectedEventID && selectedEventDate) {
            setError('');
            doStatistics();
        }
    }, [selectedEventDate]);
    var doStatistics = function () {
        if (selectedEventID && selectedEventDate) {
            var dateStr = new Date(selectedEventDate).toISOString().split('T')[0];
            axios_1.default
                .get("/api/livestream/statistics?event_id=".concat(selectedEventID, "&start=").concat(dateStr, "&end=").concat(dateStr))
                .then(function (response) {
                if (JSON.stringify(response.data) === JSON.stringify(window.prevStatistics)) {
                    return;
                }
                setStatistics(response.data);
                window.prevStatistics = response.data;
            })
                .catch(function () {
                setError('There was an error fetching the statistics');
            });
        }
    };
    var columns = [
        {
            field: 'country',
            headerName: 'Country',
            width: 320,
            valueGetter: function (value) { return filterCountries(value); },
        },
        { field: 'attendance', headerName: 'Attendance', type: 'number' },
    ];
    var rows = statistics.map(function (stat, index) { return ({
        id: index + 1,
        country: stat.country,
        attendance: stat.attendance,
    }); });
    return (react_1.default.createElement(material_1.Grid, { container: true },
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(material_1.FormControl, { className: "livestream-attendance" },
                react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h1" }, "Event Statistics"),
                react_1.default.createElement(material_1.Grid, { container: true },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12, md: 8 },
                        react_1.default.createElement(material_1.FormGroup, { className: "form-group" },
                            react_1.default.createElement(material_1.FormControl, { fullWidth: true, size: "small" },
                                react_1.default.createElement(material_1.InputLabel, null, "Event:"),
                                react_1.default.createElement(material_1.Select, { value: selectedEventID, label: "Event:", onChange: chooseEvent },
                                    react_1.default.createElement(material_1.MenuItem, { value: "" }, "Select an event"),
                                    events.map(function (event) { return (react_1.default.createElement(material_1.MenuItem, { key: event.id, value: event.id }, event.title)); }))))),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12, md: 4 },
                        react_1.default.createElement(material_1.FormGroup, { className: "form-group" }, !selectedEventID ? (react_1.default.createElement(material_1.TextField, { size: "small", variant: "outlined", label: "Event Date:", disabled: true, value: "Select an event", InputProps: { readOnly: true } })) : !eventDates.length ? (react_1.default.createElement(material_1.TextField, { size: "small", variant: "outlined", label: "Event Date:", disabled: true, value: "No dates available", InputProps: { readOnly: true } })) : (react_1.default.createElement(material_1.FormControl, { fullWidth: true, size: "small" },
                            react_1.default.createElement(material_1.InputLabel, null, "Event Date:"),
                            react_1.default.createElement(material_1.Select, { value: selectedEventDate
                                    ? new Date(selectedEventDate).toISOString().split('T')[0]
                                    : '', label: "Event Date:", onChange: function (e) {
                                    return setSelectedEventDate(new Date(e.target.value));
                                } },
                                react_1.default.createElement(material_1.MenuItem, { value: "" }, "Select a date"),
                                eventDates.map(function (eventDate) {
                                    var dateStr = new Date(eventDate.date).toISOString().split('T')[0];
                                    return (react_1.default.createElement(material_1.MenuItem, { key: dateStr, value: dateStr }, dateStr));
                                })))))),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 }, error && (react_1.default.createElement(material_1.Typography, { color: "error.main", className: "error" }, error))),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 }, !error && statistics.length > 0 && (react_1.default.createElement(material_1.Box, { id: "results" },
                        react_1.default.createElement(material_1.ButtonGroup, { variant: "contained" },
                            react_1.default.createElement(material_1.Button, { variant: "contained", sx: { float: 'right', mb: 1 }, onClick: function () {
                                    var copyText = document.getElementById('copyText');
                                    copyText.style.display = 'block';
                                    copyText.select();
                                    copyText.setSelectionRange(0, 99999);
                                    if (navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) {
                                        navigator.clipboard.writeText(copyText.value).then(function () {
                                            setTextCopied(true);
                                        });
                                    }
                                    else {
                                        document.execCommand('copy');
                                    }
                                    copyText.style.display = 'none';
                                } }, textCopied ? (react_1.default.createElement(material_1.Box, { component: "span", sx: { display: 'flex', alignItems: 'center' } },
                                react_1.default.createElement(icons_material_1.CheckCircle, { sx: { color: 'white', mr: 1 } }),
                                "Text copied!")) : (react_1.default.createElement(material_1.Box, { component: "span", sx: { display: 'flex', alignItems: 'center' } },
                                react_1.default.createElement(icons_material_1.ContentCopy, { sx: { color: 'white', mr: 1 } }),
                                "Copy as Text"))),
                            react_1.default.createElement(material_1.Button, { variant: "contained", sx: { float: 'right', mb: 1 }, onClick: function () {
                                    setOpen(true);
                                } },
                                react_1.default.createElement(icons_material_1.Map, { sx: { color: 'white', mr: 1 } }),
                                "View on Map")),
                        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(x_data_grid_1.DataGrid, { rows: rows, columns: columns, autoHeight: true, disableRowSelectionOnClick: true, getRowClassName: function (params) {
                                    return params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
                                }, className: "statistics-table" })))))))),
        react_1.default.createElement(material_1.Box, { component: "textarea", id: "copyText", sx: { display: 'none' }, readOnly: true, value: !error && statistics.length > 0
                ? ((_d = selectedEventName.split(',')[0]) !== null && _d !== void 0 ? _d : selectedEventName) +
                    ' - ' +
                    new Date(selectedEventDate).toLocaleDateString() +
                    '\n' +
                    statistics
                        .map(function (stat) {
                        return filterCountries(stat.country).padEnd(28, ' ') + stat.attendance;
                    })
                        .join('\n') +
                    '\n\n' +
                    'Total'.padEnd(28, ' ') +
                    rows.reduce(function (acc, row) { return acc + row.attendance; }, 0)
                : '', rows: 10 }),
        !error && statistics.length > 0 && (react_1.default.createElement(material_1.Modal, { open: open, onClose: function () {
                setOpen(false);
            } },
            react_1.default.createElement(material_1.Box, { sx: {
                    display: 'flex',
                    width: '100%',
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    bgcolor: 'white',
                } },
                react_1.default.createElement(material_1.Box, { sx: { position: 'absolute', zIndex: 100, top: 8, right: 8, cursor: 'pointer' }, onClick: function () {
                        setOpen(false);
                    } },
                    react_1.default.createElement(icons_material_1.Cancel, null)),
                react_1.default.createElement(LivestreamAttendanceMap_1.default, { statistics: statistics, title: (_e = selectedEventName.split(',')[0]) !== null && _e !== void 0 ? _e : 'Livestream Event', date: selectedEventDate, googleKey: googleKey }))))));
};
exports.default = LivestreamAttendance;
var renderElement = document.getElementById('livestream-attendance');
if (renderElement) {
    (0, mountIsland_1.mountIsland)(renderElement, react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(LivestreamAttendance, null)));
}
